import { useLazyGetAllUIPermissionsQuery } from "../store/services/permissionsQuery";
import {
  useApproveUserMutation,
  useCreateUserMutation,
  useDefaultRoleUpdateMutation,
  useGetAllUserMutation,
  useLazySelectUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useChangePasswordMutation,
  useLazyGetUserRolesQuery,
} from "../store/services/usersQuery";

export const useUsers = () => {
  const [
    getAllUserFunc,
    {
      data: getAllUserData,
      isLoading: getAllUserIsLoading,
      isError: getAllUserIsError,
      error: getAllUserError,
      isSuccess: getAllUserSuccess,
    },
  ] = useGetAllUserMutation();

  const [
    createUser,
    {
      data: createUserData,
      isLoading: createUserIsLading,
      isError: createUserIsError,
      error: createUserError,
      isSuccess: createUserSuccess,
    },
  ] = useCreateUserMutation();

  const [
    selectUser,
    {
      data: selectUserData,
      isLoading: selectUserIsLading,
      isError: selectUserIsError,
      error: selectUserError,
      isSuccess: selectUserSuccess,
    },
  ] = useLazySelectUserQuery();

  const [
    updateUser,
    {
      data: updateUserData,
      isLoading: updateUserIsLading,
      isError: updateUserIsError,
      error: updateUserError,
      isSuccess: updateUserSuccess,
    },
  ] = useUpdateUserMutation();

  const [
    approveUser,
    {
      data: approveUserData,
      isLoading: approveUserIsLading,
      isError: approveUserIsError,
      error: approveUserError,
      isSuccess: approveUserSuccess,
    },
  ] = useApproveUserMutation();

  const [
    getAllUIPermissions,
    {
      data: uIPermissionData,
      isLoading: uIPermissionIsLoading,
      isError: uIPermissionIsError,
      error: uIPermissionError,
      isSuccess: uIPermissionIsSuccess,
    },
  ] = useLazyGetAllUIPermissionsQuery();

  const [
    switchUser,
    {
      data: switchRoleData,
      isLoading: switchRoleIsLading,
      isError: switchRoleIsError,
      error: switchRoleError,
      isSuccess: switchRoleSuccess,
    },
  ] = useDefaultRoleUpdateMutation();

  const [
    deleteUser,
    {
      data: deleteUserData,
      isLoading: deleteUserIsLading,
      isError: deleteUserIsError,
      error: deleteUserError,
      isSuccess: deleteUserIsSuccess,
    },
  ] = useDeleteUserMutation();

  const [
    changePassword,
    {
      data: changePasswordData,
      isLoading: changePasswordIsLading,
      isError: changePasswordIsError,
      error: changePasswordError,
      isSuccess: changePasswordIsSuccess,
    },
  ] = useChangePasswordMutation();

  const [
    getLoggedInUserRoles,
    {
      data: loggedInUserRolesData,
      isLoading: loggedInUserRolesIsLading,
      isError: loggedInUserRolesIsError,
      error: loggedInUserRolesError,
      isSuccess: loggedInUserRolesIsSuccess,
    },
  ] = useLazyGetUserRolesQuery();

  return {
    getAllUserFunc,
    getAllUserData,
    getAllUserIsLoading,
    getAllUserIsError,
    getAllUserError,
    getAllUserSuccess,
    createUser,
    createUserData,
    createUserIsLading,
    createUserIsError,
    createUserError,
    createUserSuccess,
    selectUser,
    selectUserData,
    selectUserIsLading,
    selectUserIsError,
    selectUserError,
    selectUserSuccess,
    updateUser,
    updateUserData,
    updateUserIsLading,
    updateUserIsError,
    updateUserError,
    updateUserSuccess,
    approveUser,
    approveUserData,
    approveUserIsLading,
    approveUserIsError,
    approveUserError,
    approveUserSuccess,
    getAllUIPermissions,
    uIPermissionData,
    uIPermissionError,
    uIPermissionIsLoading,
    uIPermissionIsSuccess,
    uIPermissionIsError,
    switchUser,
    switchRoleData,
    switchRoleIsLading,
    switchRoleIsError,
    switchRoleError,
    switchRoleSuccess,
    deleteUser,
    deleteUserData,
    deleteUserIsLading,
    deleteUserIsError,
    deleteUserError,
    deleteUserIsSuccess,
    changePassword,
    changePasswordData,
    changePasswordIsLading,
    changePasswordIsError,
    changePasswordError,
    changePasswordIsSuccess,
    getLoggedInUserRoles,
    loggedInUserRolesData,
    loggedInUserRolesIsLading,
    loggedInUserRolesIsError,
    loggedInUserRolesError,
    loggedInUserRolesIsSuccess,
  };
};
